import { Axis } from '../../axis/axis.class';
import { Vertex3 } from '../vertex-3.class';

export const move3OnAxisCfn = (source: Vertex3, distance: number, axis: Axis): Vertex3 => {
	let dx = 0;
	let dy = 0;
	let dz = 0;

	if (axis.x !== null) {
		dz += Math.cos(axis.xr) * distance;
		dy += Math.sin(axis.xr) * distance;
	}

	if (axis.y !== null) {
		dx += Math.cos(-axis.yr) * distance;
		dz += Math.sin(-axis.yr) * distance;
	}

	if (axis.z !== null) {
		dx += Math.cos(axis.zr) * distance;
		dy += Math.sin(axis.zr) * distance;
	}

	// Add the displacement vector to the source point to get the moved point
	source.add(new Vertex3({ dataIn: {
		x: dx,
		y: dy,
		z: dz
	}}));

	return source;
}
